if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('custom-swiper');
      this.swiperWrapper = this.querySelector('.swiper-wrapper');
      this.productHandle = this.dataset.productHandle;
      this.showUnavailable = this.dataset.showUnavailable === 'true';
      this.maxProducts = parseInt(this.dataset.maxProducts, 10) || 8;

      this.fetchRecentProducts();
    }

    async fetchRecentProducts() {
      if (!window.Shopify || !window.Shopify.routes || !window.Shopify.routes.root) {
        setTimeout(() => this.fetchRecentProducts(), 100);
        return;
      }

      const stored = localStorage.getItem('recently-viewed');
      if (!stored) return;

      const handles = stored
        .split(',')
        .filter(h => h && h !== this.productHandle && h !== 'undefined')
        .slice(0, this.maxProducts);

      if (handles.length === 0) return;

      const results = await Promise.all(handles.map(handle => this.fetchCardHtml(handle)));

      for (const html of results) {
        if (!html) continue;
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.insertAdjacentHTML('beforeend', html);

        const card = slide.querySelector('.product-card-custom');
        if (!card) continue;

        if (!this.showUnavailable && card.querySelector('.product-card-custom__sold-out-badge')) {
          continue;
        }

        this.swiperWrapper.appendChild(slide);
      }

      this.swiperEl?.swiper?.update();
    }

    async fetchCardHtml(handle) {
      try {
        const res = await fetch(`${window.Shopify.routes.root}products/${handle}?view=card`);

        if (!res.ok) {
          const current = localStorage.getItem('recently-viewed') || '';
          const cleaned = current.replace(`${handle},`, '').replace(handle, '');
          localStorage.setItem('recently-viewed', cleaned);
          return null;
        }

        return await res.text();
      } catch {
        return null;
      }
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
